import { parseDate, formatDate } from 'shared-components';
import { useMemo } from 'react';
import { MaturityStatus } from '../../../types';
import { sortMaturity } from '../../../utilities/sortStudents';
import { Badge, Tooltip } from '@chakra-ui/react';
import { BadgeWrap } from '../../organisms/CASDataGrid/grid-columns/styles';
import { useTranslation } from "react-i18next";

const FundsMatured = (props: { maturityStatus: MaturityStatus[] }) => {
    const { t } = useTranslation('common');
  const maturityStatus: MaturityStatus[] | null = useMemo(() => {
    if (Array.isArray(props.maturityStatus)) {
      return sortMaturity(props.maturityStatus);
    }
    return null;
  }, [props.maturityStatus]);

  if (!maturityStatus) {
    return null;
  }

  const statusLength = maturityStatus.length;

  const maturityStatusUi = (val: MaturityStatus, index: number) => {
    const getBadgeColor = () => {
      switch (val.type) {
        case 'SUCCESS':
          return 'green';
        case 'OK':
          return 'cyan';
        case 'WARNING':
          return 'yellow';
        case 'ERROR':
          return 'red';

        default:
          return 'gray';
      }
    };

    const colorScheme = getBadgeColor();

    let { value } = val;
    // Check if value matches DD/MM/YYYY format
    const dateFormatRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
    if (dateFormatRegex.test(value)) {
      // Convert DD/MM/YYYY to ISO format for parsing
      const parts = value.split('/');
      if (parts.length === 3) {
        const isoDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        const parsedDate = parseDate(isoDate);
        if (parsedDate) {
          value = formatDate(parsedDate, 'DD MMM YYYY');
        }
      }
    }
    return (
      <Badge key={index} colorScheme={colorScheme}>
        {value}
      </Badge>
    );
  };

  if (statusLength === 0) {
    return 'None';
  }

  if (statusLength === 1) {
    return <BadgeWrap>{maturityStatus.map(maturityStatusUi)}</BadgeWrap>;
  }
  return (
    <Tooltip
      hasArrow
      placement="top-end"
      label={t('common:text2', { join: maturityStatus.map((val: MaturityStatus, index: number) => `${index + 1}. ${val.value}`).join(', ') })}
    >
      <BadgeWrap>{maturityStatus.map(maturityStatusUi)}</BadgeWrap>
    </Tooltip>
  );
};

export default FundsMatured;
